import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";
import { ActionItemsState } from "../../models/shared/action-items-state";
import { AppState } from "../../reducers";
import { ActionItemsSelectors } from "../../selectors/action-items.selectors";

@Injectable()
export class VendorActionItemsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.actionItems.get),
			withLatestFrom(this.store.select(ActionItemsSelectors.actionItems)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(VendorActions.actionItems.getSuccess({ ...state, loading: false }))
					: of(VendorActions.actionItems.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.actionItems.getApi),
			switchMap((action) =>
				this.vendorService.actionItems().pipe(
					map((actionItems) =>
						VendorActions.actionItems.getSuccess({ actionItems, loading: false })
					),
					catchError((error) =>
						of(VendorActions.actionItems.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorService: VendorService,
		private store: Store<AppState>
	) {}

	canUseStoreValue(state: ActionItemsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
